import I from '../types.ts';

const setHeight: I['setHeight'] = function () {
    const innerNode = this.parent.current!.querySelector(
        '.publicLegalHeader__pageBoxInner',
    ) as HTMLElement;
    const publicNode = document.querySelector('.public') as HTMLElement;

    if (innerNode) {
        let contentHeight = innerNode.offsetHeight;
        const offsetTop = -(
            publicNode.getBoundingClientRect().y - innerNode.getBoundingClientRect().y
        );

        if (contentHeight > document.documentElement.clientHeight - offsetTop) {
            contentHeight = document.documentElement.clientHeight - offsetTop;
        }

        this.setState({ contentHeight }, () => {
            setTimeout(() => {
                this.setState({ contentHeight: undefined });
            }, 300);
        });
    }
};

export default setHeight;
